/**
 * Service pour la gestion des rapports de problème en cours de location
 */

import api from './api';

class ProblemReportService {
  /**
   * Créer un rapport de problème
   * @param {Object} problemData - Données du problème
   * @param {string} problemData.reservation_id - ID de la réservation
   * @param {string} problemData.description - Description du problème
   * @param {Array} problemData.photos - Photos du problème
   * @returns {Promise<Object>} - Réponse de l'API
   */
  static async createProblemReport(problemData) {
    try {
      const response = await api.post('/condition-reports/problem', problemData);
      return response.data;
    } catch (error) {
      console.error('Erreur ProblemReportService.createProblemReport:', error);
      throw error;
    }
  }

  /**
   * Récupérer les rapports de problème pour une réservation
   * @param {string} reservationId - ID de la réservation
   * @returns {Promise<Array>} - Liste des rapports de problème
   */
  static async getProblemReports(reservationId) {
    try {
      const response = await api.get(`/condition-reports/problem/${reservationId}`);
      return response.data.data || [];
    } catch (error) {
      console.error('Erreur ProblemReportService.getProblemReports:', error);
      throw error;
    }
  }
}

export default ProblemReportService;
